import React from "react"
import * as S from "./elements"

interface Props {
  items: {
    key: string
    value: string
  }[]
}

export const ThisConfiguration: React.FC<Props> = ({ items }) => {
  return (
    <S.Wrapper>
      <S.Items>
        {items.map((item, key) => (
          <div key={key}>
            <S.Key>{item.key}</S.Key>
            <S.Value>{item.value}</S.Value>
          </div>
        ))}
      </S.Items>
    </S.Wrapper>
  )
}
